// extracted by mini-css-extract-plugin
module.exports =  {"buttonSkeleton":"SkeletonButton-module__buttonSkeleton___mKsn_","small":"SkeletonButton-module__small___IICRH"};